import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';

export type AdminBooking = {
  id: string;
  user_id: string;
  carer_id: string;
  care_type: string;
  start_date: string;
  end_date: string | null;
  start_time: string | null;
  end_time: string | null;
  notes: string | null;
  status: string;
  created_at: string;
  user_email?: string;
  carer_email?: string;
};

const useAdminBookings = () => {
  const queryFn = async (): Promise<AdminBooking[]> => {
    const { data, error } = await supabaseClient
      .from('booking_requests')
      .select(`
        *,
        user:user_id(email),
        carer:carer_id(email)
      `)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching admin bookings:', error);
      throw new Error(error.message);
    }

    // Transform the data to flatten user and carer emails
    const bookings = (data || []).map((booking: any) => ({
      ...booking,
      user_email: booking.user?.email || 'Unknown',
      carer_email: booking.carer?.email || 'Unknown',
    }));

    return bookings;
  };

  return useQuery<AdminBooking[], Error>({
    queryKey: ['admin-bookings'],
    queryFn,
  });
};

export default useAdminBookings;
